import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  SUGGESTION_GET_REPORT,
  SUGGESTION_GET_TOPIC,
  SUGGESTION_SHEET,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'suggest' })
export default class Suggest extends VuexModule {
  suggestMember: any = [];

  @Mutation
  mutateSuggest(suggest) {
    this.suggestMember = suggest;
  }

  @Action({ commit: 'mutateSuggest' })
  FetchSuggest(params) {
    return Vue.axios({
      url: BASE_URL + SUGGESTION_GET_REPORT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const suggest = data.data;
          return suggest;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  FecthTopic() {
    return Vue.axios({
      url: BASE_URL + SUGGESTION_GET_TOPIC,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const topics = data.data;
          return topics;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  DownloadSheet(params) {
    return Vue.axios({
      url: BASE_URL + SUGGESTION_SHEET,
      data: params,
      method: M_POST,
    })
      .then((data) => {
        const { code, message } = data.data.status;
        if (code === 0) {
          return data.data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
